export const supportedLanguages = ['de', 'en', 'nl', 'fr', 'no', 'es', 'sk'];

const languageAliases = {
  nb: 'no',
  nn: 'no'
};

export const normalizeLanguage = (language) => {
  if (typeof language !== 'string') return null;

  const baseLanguage = language.trim().toLowerCase().split(/[-_]/)[0];
  const normalizedLanguage = languageAliases[baseLanguage] || baseLanguage;

  return supportedLanguages.includes(normalizedLanguage)
    ? normalizedLanguage
    : null;
};



// WEBPACK FOOTER //
// ./src/utils/language.js